import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function DuplicateModal({ existingTemplates, saveErrorMessage, show, template, onHide, onSave }) {
  const [newDocName, setNewDocName] = React.useState(''); // template is empty on first render
  const [inputErrorMessage, setInputErrorMessage] = React.useState('');
  const [saving, setSaving] = React.useState(false);

  const largeIconStyle = {
    width: '50px',
    height: '50px',
    color: '#7422ce',
  };
  
  const onHideLocal = () => {
    setNewDocName('');
    setInputErrorMessage('');
    setSaving(false);
    onHide();
  };

  const handleInputChange = (event) => {
    const newName = event.target.value.trim();
    setNewDocName(event.target.value);

    if (!newName) {
      setInputErrorMessage('Name cannot be blank');
    } else if (templateNameExists(newName)) {
      setInputErrorMessage('Name is already in use');
    } else {
      setInputErrorMessage('');
    }
  };

  const templateNameExists = name => existingTemplates.some(t => t.name === name);

  const tryNextName = (name) => {
    const match = name.match(/(.*? - copy )(\d+)$/);
    if (match) {
      return `${match[1]}${parseInt(match[2]) + 1}`;
    } else {
      return `${name} - copy 1`;
    }
  };

  const calcNewName = (name) => {
    let trialName = name;
    while (templateNameExists(trialName)) {
      trialName = tryNextName(trialName);
    }
    return trialName;
  };

  const handleShow = () => setNewDocName(calcNewName(template.name));

  const handleSave = () => {
    setSaving(true);
    onSave({ duplicateId: template.id, newName: newDocName });
  };

  return (
    <Modal show={show} onHide={onHideLocal} onShow={handleShow}>
      <Modal.Body>
        <div className="text-center p-5">
          <div className="pb-4">
            <FontAwesomeIcon icon="fa-solid fa-circle-exclamation" style={largeIconStyle} />
          </div>
          <h3 className="text-bold mt-2">Are you sure you want to duplicate this document?</h3>
          <p>
            Duplicated documents will inherit their look & feel, margins, options, and other capabilities 
            from the document they are duplicated from. These cannot be changed.
          </p>
        </div>
        <div className="text-left px-5">
          <p className="text-bold pb-2">New template name:</p>
          <input className="form-control" type="text" value={newDocName} onChange={handleInputChange}/>
          <div className="text-danger mt-2" style={{ minHeight: '2em' }}>{inputErrorMessage || saveErrorMessage}</div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="text-right">
          <button className="btn btn-cancel mr-2" name="cancel" onClick={onHideLocal}>
            Cancel
          </button>
          <button className="btn btn-save" disabled={inputErrorMessage || saving} name="save" onClick={handleSave}>
            Save New Template
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

const templatePropType = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string
});

DuplicateModal.propTypes = {
  existingTemplates: PropTypes.arrayOf(templatePropType),
  saveErrorMessage: PropTypes.string,
  show: PropTypes.bool.isRequired,
  template: templatePropType.isRequired,
  onHide: PropTypes.func,
  onSave: PropTypes.func
};
